import styled from "styled-components";


export const FieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 10px;
  padding-right: 10px;  
`;

export const FieldItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

export const FieldLabel = styled.div`
  font-weight: 500;
  color: #444;
  flex: 0 0 180px; /* keeps labels aligned */
`;

export const FieldValue = styled.div`
  flex: 1;
  text-align: right;
  color: #333;
  word-break: break-word; /* long URLs/paths wrap cleanly */
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #666;
  font-size: 14px;
`;
